import { useState } from 'react'
import { useStore } from '../store/store'
import { Button } from './ui'

const JURISDICTIONS = ['United States', 'United Kingdom', 'European Union', 'Canada', 'Australia', 'Other / Not listed']

export function DisclaimerGate() {
  const accepted = useStore((s) => s.meta.acceptedLegalDisclaimer)
  const acceptDisclaimer = useStore((s) => s.acceptDisclaimer)
  const [jurisdiction, setJurisdiction] = useState('')
  const [checks, setChecks] = useState({ loss: false, legal: false, research: false })

  if (accepted) return null
  const ready = jurisdiction !== '' && checks.loss && checks.legal && checks.research

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <h1 style={{ marginBottom: 4 }}>EdgeLab — read this first</h1>
        <p className="muted" style={{ marginTop: 0 }}>
          EdgeLab is a research, education, journaling and <strong>paper-trading</strong> tool. It does not place real
          trades or bets, and it never guarantees profit.
        </p>
        <ul className="muted" style={{ paddingLeft: 18 }}>
          <li>Trading and betting can and do lose money — sometimes all of it.</li>
          <li>No model here is a "sure win". Every estimate carries uncertainty.</li>
          <li>You are responsible for using only legal markets in your own jurisdiction.</li>
          <li>This is not financial, investment, legal, or betting advice.</li>
        </ul>

        <div className="field">
          <label>
            <span>Your jurisdiction</span>
          </label>
          <select value={jurisdiction} onChange={(e) => setJurisdiction(e.target.value)}>
            <option value="">Select…</option>
            {JURISDICTIONS.map((j) => (
              <option key={j} value={j}>
                {j}
              </option>
            ))}
          </select>
        </div>

        <Check label="I understand trading and betting can lose money." checked={checks.loss} onChange={(v) => setChecks((c) => ({ ...c, loss: v }))} />
        <Check label="I will only use markets that are legal where I live." checked={checks.legal} onChange={(v) => setChecks((c) => ({ ...c, legal: v }))} />
        <Check
          label="I will treat outputs as research, and paper-trade first."
          checked={checks.research}
          onChange={(v) => setChecks((c) => ({ ...c, research: v }))}
        />

        <div style={{ marginTop: 16 }}>
          <Button variant="primary" disabled={!ready} onClick={() => acceptDisclaimer(jurisdiction)}>
            I understand — enter EdgeLab
          </Button>
        </div>
      </div>
    </div>
  )
}

function Check({ label, checked, onChange }: { label: string; checked: boolean; onChange: (v: boolean) => void }) {
  return (
    <label className="row" style={{ alignItems: 'flex-start', gap: 9, cursor: 'pointer', marginBottom: 9 }}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} style={{ width: 16, height: 16, marginTop: 2, accentColor: 'var(--accent)' }} />
      <span>{label}</span>
    </label>
  )
}
